// // import React, { useEffect, useRef, useState } from "react";
// // import { useDispatch, useSelector } from "react-redux";
// // import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
// // import { add_BillDiscount } from "../features/POS";
// // import {
// //   CustomerInput_Onchange,
// //   Modify_Vouchers,
// // } from "../features/Transactionstates";
// // import { API_FETCH, API_POST } from "../General/Utility";

// // // en-IN => lakh/crore grouping (same as PosView)
// // const INR = new Intl.NumberFormat("en-IN", {
// //   style: "currency",
// //   currency: "INR",
// // });
// // const fmtINR = (v) => INR.format(Number(v) || 0);
// // // null / undefined -> "" ; non numeric -> 0 ; blank day counts -> "0" (INT columns on the server)
// // const S = (v) => (v === null || v === undefined ? "" : v);
// // const N = (v) => (v === "" || v === null || v === undefined || !Number.isFinite(Number(v)) ? 0 : Number(v));
// // const dayStr = (v) => {
// //   const n = parseInt(v, 10);
// //   return Number.isFinite(n) ? String(n) : "0";
// // };

// // function POSReturn(props) {
// //   const dispatch = useDispatch();
// //   const _AuthParems = useSelector((state) => state.Common.Admin);
// //   const _Common = useSelector((store) => store.Transstates.Common);
// //   const _Pos = useSelector((state) => state.Pointofsales.Pos);

// //   const [strSearch, setstrSearch] = useState("");
// //   const [strFromDate, setstrFromDate] = useState("");
// //   const [strToDate, setstrToDate] = useState("");
// //   const [VouchersList, setVouchersList] = useState([]);
// //   const [isLoading, setisLoading] = useState(false);

// //   const itemRefs = useRef([]);
// //   const reqSeq = useRef(0); // only the latest response may update the list
// //   const searchTimer = useRef(null);
// //   const openingRef = useRef(false); // blocks double-open of the same return
// //   const closeRef = useRef(props.Close);
// //   closeRef.current = props.Close;

// //   useEffect(() => {
// //     fetchVouchers("", "", "");
// //     const onKey = (e) => {
// //       if (e.key === "Escape") {
// //         e.preventDefault();
// //         if (closeRef.current) closeRef.current();
// //       }
// //     };
// //     document.addEventListener("keydown", onKey);
// //     return () => {
// //       document.removeEventListener("keydown", onKey);
// //       clearTimeout(searchTimer.current);
// //     };
// //     // eslint-disable-next-line
// //   }, []);

// //   const fetchVouchers = async (Search, FromDate, ToDate) => {
// //     const seq = ++reqSeq.current;
// //     try {
// //       setisLoading(true);
// //       const res = await API_POST(
// //         `POS/Load_Vouchers/`,
// //         {
// //           iBranchId: Number(_AuthParems.Branch),
// //           strFromDate: FromDate,
// //           strToDate: ToDate,
// //           strSearch: Search,
// //           iScrId: 96,
// //           strDBName: _AuthParems.DB,
// //           // FIX: localStorage.Counter does not exist -> NaN -> null -> HTTP 400
// //           // (same bug that was already fixed in PosView.js)
// //           iCounterId:
// //             Number(_Common?.iCounterId) ||
// //             Number(_Pos?.iCounterId) ||
// //             Number(_AuthParems.Counter) ||
// //             0,
// //         },
// //         dispatch
// //       );
// //       if (seq !== reqSeq.current) return; // a newer request is in flight
// //       if (res) {
// //         setstrFromDate(res.strFromDate);
// //         setstrToDate(res.strToDate);
// //         setVouchersList(res.objVouchers || []);
// //       }
// //     } catch (err) {
// //       if (seq === reqSeq.current)
// //         Show_Message(dispatch, err.message, "error");
// //     } finally {
// //       if (seq === reqSeq.current) setisLoading(false);
// //     }
// //   };

// //   const Search_Change = (value) => {
// //     setstrSearch(value);
// //     clearTimeout(searchTimer.current);
// //     searchTimer.current = setTimeout(() => {
// //       searchTimer.current = null;
// //       fetchVouchers(value, strFromDate, strToDate);
// //     }, 300);
// //   };
// //   const Date_Change = (isFrom, value) => {
// //     const from = isFrom ? value : strFromDate;
// //     const to = isFrom ? strToDate : value;
// //     isFrom ? setstrFromDate(value) : setstrToDate(value);
// //     if (from && to && from > to) {
// //       Show_Message(dispatch, "From Date cannot be after To Date", "info");
// //       return;
// //     }
// //     clearTimeout(searchTimer.current);
// //     searchTimer.current = null;
// //     fetchVouchers(strSearch, from, to);
// //   };
// //   const focusItem = (i) => {
// //     const el = itemRefs.current[i];
// //     if (el) el.focus();
// //   };
// //   const Not_Ready = (e, name) => {
// //     e.preventDefault();
// //     Show_Message(dispatch, `${name} is not available yet`, "info");
// //   };

// //   // Opens an existing Sales Return on the POS screen.
// //   // The screen reads Transstates (Header / Data / Summary / Customer), exactly like
// //   // Pointofsales.Load_SelectedInvoice, so the voucher is loaded through Modify_Vouchers.
// //   // (It used to dispatch the legacy features/POS actions that the screen never reads,
// //   // so the popup closed and the cart stayed empty.)
// //   const View_PosReturn = async (vouchid) => {
// //     if (openingRef.current) return;
// //     openingRef.current = true;
// //     try {
// //       Pre_Loading(dispatch, true);
// //       const res = await API_FETCH(
// //         `POS/View_ReturnVoucherDetails/${vouchid}/${Number(
// //           _AuthParems.Branch
// //         )}/${_AuthParems.DB}`,
// //         dispatch
// //       );
// //       // error / empty => stay in this popup (API_FETCH already showed the message)
// //       if (!res || !res.objEntHT || res.objEntHT.length === 0) return;

// //       const _EntHT = res.objEntHT[0];
// //       const PartyList = res.objPartyList || [];
// //       const Sm = res.objEntSummary || {};
// //       const today = new Date().toISOString().split("T")[0];
// //       const D = (v) => (v ? v : today);

// //       const HT = {
// //         ..._EntHT,
// //         iNumSeqNo: N(_EntHT.iNumSeqNo),
// //         strPrefix: S(_EntHT.strPrefix),
// //         strCompCode: S(_EntHT.strCompCode),
// //         strFinanFrom: S(_EntHT.strFinanFrom),
// //         strTransNo: S(_EntHT.strTransNo),
// //         strVouchNo: S(_EntHT.strVouchNo),
// //         strRefNum1: S(_EntHT.strRefNum1),
// //         strRefNum2: S(_EntHT.strRefNum2),
// //         strRefNum3: S(_EntHT.strRefNum3),
// //         strRefNum4: S(_EntHT.strRefNum4),
// //         dpRefNum1Date: D(_EntHT.dpRefNum1Date),
// //         dpRefNum2Date: D(_EntHT.dpRefNum2Date),
// //         dpRefNum3Date: D(_EntHT.dpRefNum3Date),
// //         dpRefNum4Date: D(_EntHT.dpRefNum4Date),
// //         strRemark1: S(_EntHT.strRemark1),
// //         strRemark2: S(_EntHT.strRemark2),
// //         strRemark3: S(_EntHT.strRemark3),
// //         strRemark4: S(_EntHT.strRemark4),
// //         iDMId: N(_EntHT.iDMId),
// //         strConvertDCVouch: S(_EntHT.strConvertDCVouch),
// //         strPartyDCVouch: S(_EntHT.strPartyDCVouch),
// //         // Validity / Pay term / Delivery term are INT columns: "" => MySQL
// //         // "Incorrect integer value: '' for column 'ValidityDays'"
// //         strValidity: dayStr(_EntHT.strValidity),
// //         strPayTerm: dayStr(_EntHT.strPayTerm),
// //         strDeliTerm: dayStr(_EntHT.strDeliTerm),
// //         dpValDateUpto: D(_EntHT.dpValDateUpto),
// //         dpPayTermDateUpto: D(_EntHT.dpPayTermDateUpto),
// //         dpDelTermDateUpto: D(_EntHT.dpDelTermDateUpto),
// //         strEComGstNo: S(_EntHT.strEComGstNo),
// //         strTransport: S(_EntHT.strTransport),
// //         strVehicle: S(_EntHT.strVehicle),
// //         strDespatch: S(_EntHT.strDespatch),
// //         dpDespatchDate: D(_EntHT.dpDespatchDate),
// //         strLRNNumber: S(_EntHT.strLRNNumber),
// //         dpLRNoDate: D(_EntHT.dpLRNoDate),
// //         strAgent: S(_EntHT.strAgent),
// //         strReference: S(_EntHT.strReference),
// //         strDestination: S(_EntHT.strDestination),
// //         iPartyId: N(_EntHT.iPartyId),
// //         iTaxTypeId: N(_EntHT.iTaxTypeId),
// //         iTaxCalcOnId: N(_EntHT.iTaxCalcOnId),
// //         iAddLessBillDiscId: N(_EntHT.iAddLessBillDiscId),
// //         iThDiscId: N(_EntHT.iThDiscId),
// //         dThDiscPer: N(_EntHT.dThDiscPer),
// //         dTBillDiscPer: N(_EntHT.dTBillDiscPer),
// //         dTBillDiscAmt: N(_EntHT.dTBillDiscAmt),
// //         dTBillDiscValue: N(_EntHT.dTBillDiscValue),
// //         dTAddLessDiscPer: N(_EntHT.dTAddLessDiscPer),
// //         dTAddLessDiscAmt: N(_EntHT.dTAddLessDiscAmt),
// //         dTAddLessDiscValue: N(_EntHT.dTAddLessDiscValue),
// //         billAddId: N(_EntHT.billAddId),
// //         shippAddId: N(_EntHT.shippAddId),
// //         strPartyName: S(PartyList[0]),
// //         billAdd: S(PartyList[1]),
// //         shippAdd: S(_EntHT.strShippingAdd),
// //         isAccess: _EntHT.bCancelStatus !== true && res.objCanAccess !== false,
// //       };

// //       dispatch(
// //         Modify_Vouchers({
// //           VouchId: N(_EntHT.iPOSRetId) || N(vouchid),
// //           Data: {
// //             EntHT: [HT],
// //             EntDT: res.objEntDT || [],
// //             EntTax: res.objEntTax || [],
// //             EntPenCon: [],
// //             EntAL: res.objEntALDT || [],
// //             EntDTHelp: res.objEntDTHelp || [],
// //             Summary: {
// //               netAmt: N(Sm.netAmt),
// //               qty: N(Sm.qty),
// //               totalDiscount: N(Sm.totalDiscount),
// //               goodsValue: N(Sm.goodsValue),
// //               totalTax: N(Sm.totalTax),
// //               totalAddLess: N(Sm.totalAddLess),
// //               totalTCSTax: N(Sm.totalTCSTax),
// //               roundOff: N(Sm.roundOff),
// //             },
// //           },
// //         })
// //       );
// //       [
// //         ["PartyId", HT.iPartyId],
// //         ["PartyName", HT.strPartyName],
// //         ["Mobile", S(PartyList[2])],
// //         ["GST", S(PartyList[3])],
// //         ["ShippAdd", S(_EntHT.strShippingAdd)],
// //         ["RoyaltyPoint", 0],
// //       ].forEach(([Name, Value]) =>
// //         dispatch(CustomerInput_Onchange({ Name, Value }))
// //       );
// //       dispatch(
// //         add_BillDiscount({
// //           dBillDisPer: HT.dTBillDiscPer,
// //           dBillDisAmt: HT.dTBillDiscAmt,
// //           dBillDisValue: HT.dTBillDiscValue,
// //           dALBillDisPer: HT.dTAddLessDiscPer,
// //           dALBillDisAmt: HT.dTAddLessDiscAmt,
// //           dALBillDisValue: HT.dTAddLessDiscValue,
// //           iALBillDiscId: HT.iAddLessBillDiscId,
// //         })
// //       );
// //       // switch the POS screen to return mode only AFTER the data is in the store
// //       if (props.View_Return) props.View_Return();
// //     } catch (err) {
// //       Show_Message(dispatch, err.message, "error");
// //     } finally {
// //       Pre_Loading(dispatch, false);
// //       openingRef.current = false;
// //     }
// //   };

// //   return (
// //     <div className="popup-container">
// //       <div className="popup-content">
// //         <div className="popup-header">
// //           <h5>Return</h5>
// //           <div className="icon-popup-btn-grp">
// //             <span className="icon-btn" onClick={props.Close}>
// //               <i className="fa-regular fa-rectangle-xmark"></i>
// //             </span>
// //           </div>
// //         </div>
// //         <div className="popup-body">
// //           <div className="input-search">
// //             <input
// //               type="text"
// //               value={strSearch}
// //               onChange={(e) => Search_Change(e.target.value)}
// //               className="form-control"
// //               placeholder="Search bill number ...."
// //               autoFocus
// //               autoComplete="off"
// //               onKeyDown={(e) => {
// //                 if (e.key === "ArrowUp" || e.key === "ArrowDown") {
// //                   e.preventDefault();
// //                   focusItem(0);
// //                 } else if (e.key === "Enter") {
// //                   if (searchTimer.current) {
// //                     // search still pending: run it now instead of opening a stale row
// //                     clearTimeout(searchTimer.current);
// //                     searchTimer.current = null;
// //                     fetchVouchers(strSearch, strFromDate, strToDate);
// //                   } else if (VouchersList.length > 0) {
// //                     View_PosReturn(VouchersList[0].vouchId);
// //                   }
// //                 }
// //               }}
// //             />
// //             <input
// //               type="date"
// //               value={strFromDate}
// //               onChange={(e) => Date_Change(true, e.target.value)}
// //               className="form-control"
// //               autoComplete="off"
// //             />
// //             <input
// //               type="date"
// //               value={strToDate}
// //               onChange={(e) => Date_Change(false, e.target.value)}
// //               className="form-control"
// //               autoComplete="off"
// //             />
// //           </div>
// //           <div className="pos-view">
// //             {!isLoading && VouchersList.length === 0 && (
// //               <div
// //                 style={{ textAlign: "center", padding: "24px", color: "#888" }}
// //               >
// //                 No invoices found
// //               </div>
// //             )}
// //             {VouchersList.map((Vouch, trIndex) => (
// //               <button
// //                 key={Vouch.vouchId}
// //                 ref={(el) => (itemRefs.current[trIndex] = el)}
// //                 onDoubleClick={() => View_PosReturn(Vouch.vouchId)}
// //                 onKeyDown={(e) => {
// //                   const last = VouchersList.length - 1;
// //                   if (e.key === "ArrowDown") {
// //                     e.preventDefault();
// //                     focusItem(trIndex === last ? 0 : trIndex + 1);
// //                   } else if (e.key === "ArrowUp") {
// //                     e.preventDefault();
// //                     focusItem(trIndex === 0 ? last : trIndex - 1);
// //                   } else if (e.key === "Enter") {
// //                     e.preventDefault();
// //                     View_PosReturn(Vouch.vouchId);
// //                   }
// //                   // Escape is handled once by the document listener
// //                 }}
// //               >
// //                 <div className="bill-content">
// //                   <h6>{Vouch.partyName}</h6>
// //                   <div className="trans-cont">
// //                     <div className="transview1">
// //                       <label>
// //                         <span>Inv No : {Vouch.vouchNo}</span>
// //                         <span>Date : {Vouch.vouchDate}</span>
// //                         <span>Qty : {Number(Vouch.tQty).toFixed(2)}</span>
// //                         <span>Tax Amount : {fmtINR(Vouch.tTaxAmt)}</span>
// //                         <span>Net Amount : {fmtINR(Vouch.netAmt)}</span>
// //                       </label>
// //                       <label></label>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </button>
// //             ))}
// //           </div>
// //         </div>
// //         <div className="pos-btn-group">
// //           <div className="pos-tooltip" onClick={(e) => Not_Ready(e, "Print")}>
// //             <a className="icon-btn" href="##">
// //               <i className="fa-solid fa-print"></i>
// //             </a>
// //             <span className="pos-tooltiptxt">Print</span>
// //           </div>
// //           <div
// //             className="pos-tooltip"
// //             onClick={(e) => Not_Ready(e, "Download")}
// //           >
// //             <a className="icon-btn" href="##">
// //               <i className="fa-solid fa-download"></i>
// //             </a>
// //             <span className="pos-tooltiptxt">Download</span>
// //           </div>
// //           <div
// //             className="pos-tooltip"
// //             onClick={(e) => Not_Ready(e, "WhatsApp share")}
// //           >
// //             <a className="icon-btn" href="##">
// //               <i className="fa-brands fa-whatsapp"></i>
// //             </a>
// //             <span className="pos-tooltiptxt">whatsapp</span>
// //           </div>
// //           <div className="pos-tooltip" onClick={(e) => Not_Ready(e, "E-mail")}>
// //             <a className="icon-btn" href="##">
// //               <i className="fa-regular fa-envelope"></i>
// //             </a>
// //             <span className="pos-tooltiptxt">E-mail</span>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default POSReturn;










// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
// import { add_BillDiscount } from "../features/POS";
// import {
//   CustomerInput_Onchange,
//   Modify_Vouchers,
// } from "../features/Transactionstates";
// import { API_FETCH, API_POST } from "../General/Utility";

// // en-IN => lakh/crore grouping (same as PosView)
// const INR = new Intl.NumberFormat("en-IN", {
//   style: "currency",
//   currency: "INR",
// });
// const fmtINR = (v) => INR.format(Number(v) || 0);
// // null / undefined -> "" ; non numeric -> 0 ; blank day counts -> "0" (INT columns on the server)
// const S = (v) => (v === null || v === undefined ? "" : v);
// const N = (v) => (v === "" || v === null || v === undefined || !Number.isFinite(Number(v)) ? 0 : Number(v));
// const dayStr = (v) => {
//   const n = parseInt(v, 10);
//   return Number.isFinite(n) ? String(n) : "0";
// };

// function POSReturn(props) {
//   const dispatch = useDispatch();
//   const _AuthParems = useSelector((state) => state.Common.Admin);
//   const _Common = useSelector((store) => store.Transstates.Common);
//   const _Pos = useSelector((state) => state.Pointofsales.Pos);

//   // "new"  = search a sales INVOICE (scr 93) and return items from it
//   // "past" = list of already saved sales RETURNS (scr 96): view / modify
//   const [tab, setTab] = useState("new");
//   const [selId, setSelId] = useState(0);
//   const [strSearch, setstrSearch] = useState("");
//   const [strFromDate, setstrFromDate] = useState("");
//   const [strToDate, setstrToDate] = useState("");
//   const [VouchersList, setVouchersList] = useState([]);
//   const [isLoading, setisLoading] = useState(false);

//   const itemRefs = useRef([]);
//   const reqSeq = useRef(0); // only the latest response may update the list
//   const searchTimer = useRef(null);
//   const openingRef = useRef(false); // blocks double-open of the same return
//   const closeRef = useRef(props.Close);
//   closeRef.current = props.Close;

//   const scrOf = (t) => (t === "past" ? 96 : 93);

//   useEffect(() => {
//     fetchVouchers(tab, "", "", "");
//     const onKey = (e) => {
//       if (e.key === "Escape") {
//         e.preventDefault();
//         if (closeRef.current) closeRef.current();
//       }
//     };
//     document.addEventListener("keydown", onKey);
//     return () => {
//       document.removeEventListener("keydown", onKey);
//       clearTimeout(searchTimer.current);
//     };
//     // eslint-disable-next-line
//   }, []);

//   const fetchVouchers = async (t, Search, FromDate, ToDate) => {
//     const seq = ++reqSeq.current;
//     try {
//       setisLoading(true);
//       const res = await API_POST(
//         `POS/Load_Vouchers/`,
//         {
//           iBranchId: Number(_AuthParems.Branch),
//           strFromDate: FromDate,
//           strToDate: ToDate,
//           strSearch: Search,
//           iScrId: scrOf(t),
//           strDBName: _AuthParems.DB,
//           // FIX: localStorage.Counter does not exist -> NaN -> null -> HTTP 400
//           // (same bug that was already fixed in PosView.js)
//           iCounterId:
//             Number(_Common?.iCounterId) ||
//             Number(_Pos?.iCounterId) ||
//             Number(_AuthParems.Counter) ||
//             0,
//         },
//         dispatch
//       );
//       if (seq !== reqSeq.current) return; // a newer request is in flight
//       if (res) {
//         setstrFromDate(res.strFromDate);
//         setstrToDate(res.strToDate);
//         setVouchersList(res.objVouchers || []);
//         setSelId(0);
//       }
//     } catch (err) {
//       if (seq === reqSeq.current)
//         Show_Message(dispatch, err.message, "error");
//     } finally {
//       if (seq === reqSeq.current) setisLoading(false);
//     }
//   };

//   const Search_Change = (value) => {
//     setstrSearch(value);
//     clearTimeout(searchTimer.current);
//     searchTimer.current = setTimeout(() => {
//       searchTimer.current = null;
//       fetchVouchers(tab, value, strFromDate, strToDate);
//     }, 300);
//   };
//   const Date_Change = (isFrom, value) => {
//     const from = isFrom ? value : strFromDate;
//     const to = isFrom ? strToDate : value;
//     isFrom ? setstrFromDate(value) : setstrToDate(value);
//     if (from && to && from > to) {
//       Show_Message(dispatch, "From Date cannot be after To Date", "info");
//       return;
//     }
//     clearTimeout(searchTimer.current);
//     searchTimer.current = null;
//     fetchVouchers(tab, strSearch, from, to);
//   };
//   const Switch_Tab = (t) => {
//     if (t === tab) return;
//     clearTimeout(searchTimer.current);
//     searchTimer.current = null;
//     setTab(t);
//     setstrSearch("");
//     setstrFromDate("");
//     setstrToDate("");
//     setVouchersList([]);
//     setSelId(0);
//     fetchVouchers(t, "", "", "");
//   };
//   // one entry point for double-click / Enter / button
//   const Open_Row = (vouchId) => {
//     if (!vouchId) return;
//     if (tab === "new") {
//       // pick the invoice -> ProductReturn popup (items / qty) on the POS screen
//       if (props.New_Return) props.New_Return(vouchId);
//     } else {
//       View_PosReturn(vouchId);
//     }
//   };
//   const focusItem = (i) => {
//     const el = itemRefs.current[i];
//     if (el) el.focus();
//   };
//   const Not_Ready = (e, name) => {
//     e.preventDefault();
//     Show_Message(dispatch, `${name} is not available yet`, "info");
//   };

//   // Opens an existing Sales Return on the POS screen.
//   // The screen reads Transstates (Header / Data / Summary / Customer), exactly like
//   // Pointofsales.Load_SelectedInvoice, so the voucher is loaded through Modify_Vouchers.
//   // (It used to dispatch the legacy features/POS actions that the screen never reads,
//   // so the popup closed and the cart stayed empty.)
//   const View_PosReturn = async (vouchid) => {
//     if (openingRef.current) return;
//     openingRef.current = true;
//     try {
//       Pre_Loading(dispatch, true);
//       const res = await API_FETCH(
//         `POS/View_ReturnVoucherDetails/${vouchid}/${Number(
//           _AuthParems.Branch
//         )}/${_AuthParems.DB}`,
//         dispatch
//       );
//       // error / empty => stay in this popup (API_FETCH already showed the message)
//       if (!res || !res.objEntHT || res.objEntHT.length === 0) return;

//       const _EntHT = res.objEntHT[0];
//       const PartyList = res.objPartyList || [];
//       const Sm = res.objEntSummary || {};
//       const today = new Date().toISOString().split("T")[0];
//       const D = (v) => (v ? v : today);

//       const HT = {
//         ..._EntHT,
//         iNumSeqNo: N(_EntHT.iNumSeqNo),
//         strPrefix: S(_EntHT.strPrefix),
//         strCompCode: S(_EntHT.strCompCode),
//         strFinanFrom: S(_EntHT.strFinanFrom),
//         strTransNo: S(_EntHT.strTransNo),
//         strVouchNo: S(_EntHT.strVouchNo),
//         strRefNum1: S(_EntHT.strRefNum1),
//         strRefNum2: S(_EntHT.strRefNum2),
//         strRefNum3: S(_EntHT.strRefNum3),
//         strRefNum4: S(_EntHT.strRefNum4),
//         dpRefNum1Date: D(_EntHT.dpRefNum1Date),
//         dpRefNum2Date: D(_EntHT.dpRefNum2Date),
//         dpRefNum3Date: D(_EntHT.dpRefNum3Date),
//         dpRefNum4Date: D(_EntHT.dpRefNum4Date),
//         strRemark1: S(_EntHT.strRemark1),
//         strRemark2: S(_EntHT.strRemark2),
//         strRemark3: S(_EntHT.strRemark3),
//         strRemark4: S(_EntHT.strRemark4),
//         iDMId: N(_EntHT.iDMId),
//         strConvertDCVouch: S(_EntHT.strConvertDCVouch),
//         strPartyDCVouch: S(_EntHT.strPartyDCVouch),
//         // Validity / Pay term / Delivery term are INT columns: "" => MySQL
//         // "Incorrect integer value: '' for column 'ValidityDays'"
//         strValidity: dayStr(_EntHT.strValidity),
//         strPayTerm: dayStr(_EntHT.strPayTerm),
//         strDeliTerm: dayStr(_EntHT.strDeliTerm),
//         dpValDateUpto: D(_EntHT.dpValDateUpto),
//         dpPayTermDateUpto: D(_EntHT.dpPayTermDateUpto),
//         dpDelTermDateUpto: D(_EntHT.dpDelTermDateUpto),
//         strEComGstNo: S(_EntHT.strEComGstNo),
//         strTransport: S(_EntHT.strTransport),
//         strVehicle: S(_EntHT.strVehicle),
//         strDespatch: S(_EntHT.strDespatch),
//         dpDespatchDate: D(_EntHT.dpDespatchDate),
//         strLRNNumber: S(_EntHT.strLRNNumber),
//         dpLRNoDate: D(_EntHT.dpLRNoDate),
//         strAgent: S(_EntHT.strAgent),
//         strReference: S(_EntHT.strReference),
//         strDestination: S(_EntHT.strDestination),
//         iPartyId: N(_EntHT.iPartyId),
//         iTaxTypeId: N(_EntHT.iTaxTypeId),
//         iTaxCalcOnId: N(_EntHT.iTaxCalcOnId),
//         iAddLessBillDiscId: N(_EntHT.iAddLessBillDiscId),
//         iThDiscId: N(_EntHT.iThDiscId),
//         dThDiscPer: N(_EntHT.dThDiscPer),
//         dTBillDiscPer: N(_EntHT.dTBillDiscPer),
//         dTBillDiscAmt: N(_EntHT.dTBillDiscAmt),
//         dTBillDiscValue: N(_EntHT.dTBillDiscValue),
//         dTAddLessDiscPer: N(_EntHT.dTAddLessDiscPer),
//         dTAddLessDiscAmt: N(_EntHT.dTAddLessDiscAmt),
//         dTAddLessDiscValue: N(_EntHT.dTAddLessDiscValue),
//         billAddId: N(_EntHT.billAddId),
//         shippAddId: N(_EntHT.shippAddId),
//         strPartyName: S(PartyList[0]),
//         billAdd: S(PartyList[1]),
//         shippAdd: S(_EntHT.strShippingAdd),
//         isAccess: _EntHT.bCancelStatus !== true && res.objCanAccess !== false,
//       };

//       dispatch(
//         Modify_Vouchers({
//           VouchId: N(_EntHT.iPOSRetId) || N(vouchid),
//           Data: {
//             EntHT: [HT],
//             EntDT: res.objEntDT || [],
//             EntTax: res.objEntTax || [],
//             EntPenCon: [],
//             EntAL: res.objEntALDT || [],
//             EntDTHelp: res.objEntDTHelp || [],
//             Summary: {
//               netAmt: N(Sm.netAmt),
//               qty: N(Sm.qty),
//               totalDiscount: N(Sm.totalDiscount),
//               goodsValue: N(Sm.goodsValue),
//               totalTax: N(Sm.totalTax),
//               totalAddLess: N(Sm.totalAddLess),
//               totalTCSTax: N(Sm.totalTCSTax),
//               roundOff: N(Sm.roundOff),
//             },
//           },
//         })
//       );
//       [
//         ["PartyId", HT.iPartyId],
//         ["PartyName", HT.strPartyName],
//         ["Mobile", S(PartyList[2])],
//         ["GST", S(PartyList[3])],
//         ["ShippAdd", S(_EntHT.strShippingAdd)],
//         ["RoyaltyPoint", 0],
//       ].forEach(([Name, Value]) =>
//         dispatch(CustomerInput_Onchange({ Name, Value }))
//       );
//       dispatch(
//         add_BillDiscount({
//           dBillDisPer: HT.dTBillDiscPer,
//           dBillDisAmt: HT.dTBillDiscAmt,
//           dBillDisValue: HT.dTBillDiscValue,
//           dALBillDisPer: HT.dTAddLessDiscPer,
//           dALBillDisAmt: HT.dTAddLessDiscAmt,
//           dALBillDisValue: HT.dTAddLessDiscValue,
//           iALBillDiscId: HT.iAddLessBillDiscId,
//         })
//       );
//       // switch the POS screen to return mode only AFTER the data is in the store
//       if (props.View_Return) props.View_Return();
//     } catch (err) {
//       Show_Message(dispatch, err.message, "error");
//     } finally {
//       Pre_Loading(dispatch, false);
//       openingRef.current = false;
//     }
//   };

//   return (
//     <div className="popup-container">
//       <div className="popup-content">
//         <div className="popup-header">
//           <h5>Sales Return</h5>
//           <div className="icon-popup-btn-grp">
//             <span className="icon-btn" onClick={props.Close}>
//               <i className="fa-regular fa-rectangle-xmark"></i>
//             </span>
//           </div>
//         </div>
//         <div
//           role="tablist"
//           style={{ display: "flex", gap: "4px", padding: "0 12px", borderBottom: "1px solid #ddd" }}
//         >
//           {[
//             ["new", "New Return (Select Invoice)"],
//             ["past", "Past Returns"],
//           ].map(([key, label]) => (
//             <button
//               key={key}
//               type="button"
//               role="tab"
//               aria-selected={tab === key}
//               onClick={() => Switch_Tab(key)}
//               style={{
//                 background: "none",
//                 border: "none",
//                 padding: "8px 14px",
//                 cursor: "pointer",
//                 fontWeight: tab === key ? 700 : 400,
//                 borderBottom: tab === key ? "3px solid currentColor" : "3px solid transparent",
//               }}
//             >
//               {label}
//             </button>
//           ))}
//         </div>
//         <div className="popup-body">
//           <div className="input-search">
//             <input
//               type="text"
//               value={strSearch}
//               onChange={(e) => Search_Change(e.target.value)}
//               className="form-control"
//               placeholder={tab === "new" ? "Search invoice number ...." : "Search return number ...."}
//               autoFocus
//               autoComplete="off"
//               onKeyDown={(e) => {
//                 if (e.key === "ArrowUp" || e.key === "ArrowDown") {
//                   e.preventDefault();
//                   focusItem(0);
//                 } else if (e.key === "Enter") {
//                   if (searchTimer.current) {
//                     // search still pending: run it now instead of opening a stale row
//                     clearTimeout(searchTimer.current);
//                     searchTimer.current = null;
//                     fetchVouchers(tab, strSearch, strFromDate, strToDate);
//                   } else if (VouchersList.length > 0) {
//                     Open_Row(VouchersList[0].vouchId);
//                   }
//                 }
//               }}
//             />
//             <input
//               type="date"
//               value={strFromDate}
//               onChange={(e) => Date_Change(true, e.target.value)}
//               className="form-control"
//               autoComplete="off"
//             />
//             <input
//               type="date"
//               value={strToDate}
//               onChange={(e) => Date_Change(false, e.target.value)}
//               className="form-control"
//               autoComplete="off"
//             />
//           </div>
//           <div className="pos-view">
//             {!isLoading && VouchersList.length === 0 && (
//               <div
//                 style={{ textAlign: "center", padding: "24px", color: "#888" }}
//               >
//                 {tab === "new" ? "No invoices found" : "No returns found"}
//               </div>
//             )}
//             {VouchersList.map((Vouch, trIndex) => (
//               <button
//                 key={Vouch.vouchId}
//                 className={selId === Vouch.vouchId ? "active" : ""}
//                 ref={(el) => (itemRefs.current[trIndex] = el)}
//                 onClick={() => setSelId(Vouch.vouchId)}
//                 onDoubleClick={() => Open_Row(Vouch.vouchId)}
//                 onKeyDown={(e) => {
//                   const last = VouchersList.length - 1;
//                   if (e.key === "ArrowDown") {
//                     e.preventDefault();
//                     focusItem(trIndex === last ? 0 : trIndex + 1);
//                   } else if (e.key === "ArrowUp") {
//                     e.preventDefault();
//                     focusItem(trIndex === 0 ? last : trIndex - 1);
//                   } else if (e.key === "Enter") {
//                     e.preventDefault();
//                     Open_Row(Vouch.vouchId);
//                   }
//                   // Escape is handled once by the document listener
//                 }}
//               >
//                 <div className="bill-content">
//                   <h6>{Vouch.partyName}</h6>
//                   <div className="trans-cont">
//                     <div className="transview1">
//                       <label>
//                         <span>{tab === "new" ? "Inv No" : "Return No"} : {Vouch.vouchNo}</span>
//                         <span>Date : {Vouch.vouchDate}</span>
//                         <span>Qty : {Number(Vouch.tQty).toFixed(2)}</span>
//                         <span>Tax Amount : {fmtINR(Vouch.tTaxAmt)}</span>
//                         <span>Net Amount : {fmtINR(Vouch.netAmt)}</span>
//                       </label>
//                       <label></label>
//                     </div>
//                   </div>
//                 </div>
//               </button>
//             ))}
//           </div>
//         </div>
//         <div className="pos-btn-group">
//           <button
//             type="button"
//             className="btn-fabgreen"
//             disabled={!selId}
//             onClick={() => Open_Row(selId)}
//           >
//             {tab === "new" ? "Select Invoice" : "Open Return"}
//           </button>
//           <div className="pos-tooltip" onClick={(e) => Not_Ready(e, "Print")}>
//             <a className="icon-btn" href="##">
//               <i className="fa-solid fa-print"></i>
//             </a>
//             <span className="pos-tooltiptxt">Print</span>
//           </div>
//           <div
//             className="pos-tooltip"
//             onClick={(e) => Not_Ready(e, "Download")}
//           >
//             <a className="icon-btn" href="##">
//               <i className="fa-solid fa-download"></i>
//             </a>
//             <span className="pos-tooltiptxt">Download</span>
//           </div>
//           <div
//             className="pos-tooltip"
//             onClick={(e) => Not_Ready(e, "WhatsApp share")}
//           >
//             <a className="icon-btn" href="##">
//               <i className="fa-brands fa-whatsapp"></i>
//             </a>
//             <span className="pos-tooltiptxt">whatsapp</span>
//           </div>
//           <div className="pos-tooltip" onClick={(e) => Not_Ready(e, "E-mail")}>
//             <a className="icon-btn" href="##">
//               <i className="fa-regular fa-envelope"></i>
//             </a>
//             <span className="pos-tooltiptxt">E-mail</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default POSReturn;




import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import { add_BillDiscount } from "../features/POS";
import {
  CustomerInput_Onchange,
  Modify_Vouchers,
} from "../features/Transactionstates";
// A4: IST business date (was UTC via toISOString => wrong date 00:00-05:30 IST)
import { API_FETCH, API_POST, fnBusinessDate } from "../General/Utility";

// en-IN => lakh/crore grouping (same as PosView)
const INR = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
});
const fmtINR = (v) => INR.format(Number(v) || 0);
// null / undefined -> "" ; non numeric -> 0 ; blank day counts -> "0" (INT columns on the server)
const S = (v) => (v === null || v === undefined ? "" : v);
const N = (v) => (v === "" || v === null || v === undefined || !Number.isFinite(Number(v)) ? 0 : Number(v));
const dayStr = (v) => {
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? String(n) : "0";
};

function POSReturn(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _Common = useSelector((store) => store.Transstates.Common);
  const _Pos = useSelector((state) => state.Pointofsales.Pos);

  const [strSearch, setstrSearch] = useState("");
  const [strFromDate, setstrFromDate] = useState("");
  const [strToDate, setstrToDate] = useState("");
  const [VouchersList, setVouchersList] = useState([]);
  const [iVouchId, setiVouchId] = useState(0);
  const [isLoading, setisLoading] = useState(false);

  const itemRefs = useRef([]);
  const reqSeq = useRef(0); // only the latest response may update the list
  const searchTimer = useRef(null);
  const openingRef = useRef(false); // blocks double-open of the same return
  const actionRef = useRef(false); // blocks double print / PDF / WhatsApp / e-mail
  const closeRef = useRef(props.Close);
  closeRef.current = props.Close;

  useEffect(() => {
    fetchVouchers("", "", "");
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        if (closeRef.current) closeRef.current();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      clearTimeout(searchTimer.current);
    };
    // eslint-disable-next-line
  }, []);

  const fetchVouchers = async (Search, FromDate, ToDate) => {
    const seq = ++reqSeq.current;
    try {
      setisLoading(true);
      const res = await API_POST(
        `POS/Load_Vouchers/`,
        {
          iBranchId: Number(_AuthParems.Branch),
          strFromDate: FromDate,
          strToDate: ToDate,
          strSearch: Search,
          iScrId: 96,
          strDBName: _AuthParems.DB,
          // FIX: localStorage.Counter does not exist -> NaN -> null -> HTTP 400
          // (same bug that was already fixed in PosView.js)
          iCounterId:
            Number(_Common?.iCounterId) ||
            Number(_Pos?.iCounterId) ||
            Number(_AuthParems.Counter) ||
            0,
        },
        dispatch
      );
      if (seq !== reqSeq.current) return; // a newer request is in flight
      if (res) {
        setstrFromDate(res.strFromDate);
        setstrToDate(res.strToDate);
        setVouchersList(res.objVouchers || []);
        setiVouchId(0);
      }
    } catch (err) {
      if (seq === reqSeq.current)
        Show_Message(dispatch, err.message, "error");
    } finally {
      if (seq === reqSeq.current) setisLoading(false);
    }
  };

  const Search_Change = (value) => {
    setstrSearch(value);
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      searchTimer.current = null;
      fetchVouchers(value, strFromDate, strToDate);
    }, 300);
  };
  const Date_Change = (isFrom, value) => {
    const from = isFrom ? value : strFromDate;
    const to = isFrom ? strToDate : value;
    isFrom ? setstrFromDate(value) : setstrToDate(value);
    if (from && to && from > to) {
      Show_Message(dispatch, "From Date cannot be after To Date", "info");
      return;
    }
    clearTimeout(searchTimer.current);
    searchTimer.current = null;
    fetchVouchers(strSearch, from, to);
  };
  const focusItem = (i) => {
    const el = itemRefs.current[i];
    if (el) el.focus();
  };
  // One print / share at a time: a double click used to queue two print jobs
  // (or two WhatsApp / e-mail sends) for the same return.
  const Run_GuardedAction = async (fn) => {
    if (actionRef.current || openingRef.current) return;
    actionRef.current = true;
    try {
      await fn();
    } catch (err) {
      Show_Message(
        dispatch,
        (err && err.message) || "Unexpected error. Please try again.",
        "error"
      );
    } finally {
      actionRef.current = false;
    }
  };
  const Run_SelectedPrint = (e, PrintFor) => {
    e.preventDefault();
    if (!Number(iVouchId)) {
      Show_Message(dispatch, "Please select a return", "info");
      return;
    }
    if (props.PrintVoucher)
      Run_GuardedAction(() => props.PrintVoucher(iVouchId, PrintFor));
  };
  const Run_SelectedShare = (e, Type) => {
    e.preventDefault();
    if (!Number(iVouchId)) {
      Show_Message(dispatch, "Please select a return", "info");
      return;
    }
    if (props.ShareVoucher)
      Run_GuardedAction(() => props.ShareVoucher(iVouchId, Type));
  };

  // Opens an existing Sales Return on the POS screen.
  // The screen reads Transstates (Header / Data / Summary / Customer), exactly like
  // Pointofsales.Load_SelectedInvoice, so the voucher is loaded through Modify_Vouchers.
  // (It used to dispatch the legacy features/POS actions that the screen never reads,
  // so the popup closed and the cart stayed empty.)
  const View_PosReturn = async (vouchid) => {
    if (openingRef.current || actionRef.current) return;
    openingRef.current = true;
    try {
      await Pre_Loading(dispatch, true);
      const res = await API_FETCH(
        `POS/View_ReturnVoucherDetails/${vouchid}/${Number(
          _AuthParems.Branch
        )}/${_AuthParems.DB}`,
        dispatch
      );
      // error / empty => stay in this popup (API_FETCH already showed the message)
      if (!res || !res.objEntHT || res.objEntHT.length === 0) return;

      const _EntHT = res.objEntHT[0];
      const PartyList = res.objPartyList || [];
      const Sm = res.objEntSummary || {};
      const today = fnBusinessDate(); // A4: IST, not UTC
      const D = (v) => (v ? v : today);

      const HT = {
        ..._EntHT,
        iNumSeqNo: N(_EntHT.iNumSeqNo),
        strPrefix: S(_EntHT.strPrefix),
        strCompCode: S(_EntHT.strCompCode),
        strFinanFrom: S(_EntHT.strFinanFrom),
        strTransNo: S(_EntHT.strTransNo),
        strVouchNo: S(_EntHT.strVouchNo),
        strRefNum1: S(_EntHT.strRefNum1),
        strRefNum2: S(_EntHT.strRefNum2),
        strRefNum3: S(_EntHT.strRefNum3),
        strRefNum4: S(_EntHT.strRefNum4),
        dpRefNum1Date: D(_EntHT.dpRefNum1Date),
        dpRefNum2Date: D(_EntHT.dpRefNum2Date),
        dpRefNum3Date: D(_EntHT.dpRefNum3Date),
        dpRefNum4Date: D(_EntHT.dpRefNum4Date),
        strRemark1: S(_EntHT.strRemark1),
        strRemark2: S(_EntHT.strRemark2),
        strRemark3: S(_EntHT.strRemark3),
        strRemark4: S(_EntHT.strRemark4),
        iDMId: N(_EntHT.iDMId),
        strConvertDCVouch: S(_EntHT.strConvertDCVouch),
        strPartyDCVouch: S(_EntHT.strPartyDCVouch),
        // Validity / Pay term / Delivery term are INT columns: "" => MySQL
        // "Incorrect integer value: '' for column 'ValidityDays'"
        strValidity: dayStr(_EntHT.strValidity),
        strPayTerm: dayStr(_EntHT.strPayTerm),
        strDeliTerm: dayStr(_EntHT.strDeliTerm),
        dpValDateUpto: D(_EntHT.dpValDateUpto),
        dpPayTermDateUpto: D(_EntHT.dpPayTermDateUpto),
        dpDelTermDateUpto: D(_EntHT.dpDelTermDateUpto),
        strEComGstNo: S(_EntHT.strEComGstNo),
        strTransport: S(_EntHT.strTransport),
        strVehicle: S(_EntHT.strVehicle),
        strDespatch: S(_EntHT.strDespatch),
        dpDespatchDate: D(_EntHT.dpDespatchDate),
        strLRNNumber: S(_EntHT.strLRNNumber),
        dpLRNoDate: D(_EntHT.dpLRNoDate),
        strAgent: S(_EntHT.strAgent),
        strReference: S(_EntHT.strReference),
        strDestination: S(_EntHT.strDestination),
        iPartyId: N(_EntHT.iPartyId),
        iTaxTypeId: N(_EntHT.iTaxTypeId),
        iTaxCalcOnId: N(_EntHT.iTaxCalcOnId),
        iAddLessBillDiscId: N(_EntHT.iAddLessBillDiscId),
        iThDiscId: N(_EntHT.iThDiscId),
        dThDiscPer: N(_EntHT.dThDiscPer),
        dTBillDiscPer: N(_EntHT.dTBillDiscPer),
        dTBillDiscAmt: N(_EntHT.dTBillDiscAmt),
        dTBillDiscValue: N(_EntHT.dTBillDiscValue),
        dTAddLessDiscPer: N(_EntHT.dTAddLessDiscPer),
        dTAddLessDiscAmt: N(_EntHT.dTAddLessDiscAmt),
        dTAddLessDiscValue: N(_EntHT.dTAddLessDiscValue),
        billAddId: N(_EntHT.billAddId),
        shippAddId: N(_EntHT.shippAddId),
        strPartyName: S(PartyList[0]),
        billAdd: S(PartyList[1]),
        shippAdd: S(_EntHT.strShippingAdd),
        isAccess: _EntHT.bCancelStatus !== true && res.objCanAccess !== false,
      };

      dispatch(
        Modify_Vouchers({
          VouchId: N(_EntHT.iPOSRetId) || N(vouchid),
          Data: {
            EntHT: [HT],
            EntDT: res.objEntDT || [],
            EntTax: res.objEntTax || [],
            EntPenCon: [],
            EntAL: res.objEntALDT || [],
            EntDTHelp: res.objEntDTHelp || [],
            Summary: {
              netAmt: N(Sm.netAmt),
              qty: N(Sm.qty),
              totalDiscount: N(Sm.totalDiscount),
              goodsValue: N(Sm.goodsValue),
              totalTax: N(Sm.totalTax),
              totalAddLess: N(Sm.totalAddLess),
              totalTCSTax: N(Sm.totalTCSTax),
              roundOff: N(Sm.roundOff),
            },
          },
        })
      );
      [
        ["PartyId", HT.iPartyId],
        ["PartyName", HT.strPartyName],
        ["Mobile", S(PartyList[2])],
        ["GST", S(PartyList[3])],
        ["ShippAdd", S(_EntHT.strShippingAdd)],
        ["RoyaltyPoint", 0],
      ].forEach(([Name, Value]) =>
        dispatch(CustomerInput_Onchange({ Name, Value }))
      );
      dispatch(
        add_BillDiscount({
          dBillDisPer: HT.dTBillDiscPer,
          dBillDisAmt: HT.dTBillDiscAmt,
          dBillDisValue: HT.dTBillDiscValue,
          dALBillDisPer: HT.dTAddLessDiscPer,
          dALBillDisAmt: HT.dTAddLessDiscAmt,
          dALBillDisValue: HT.dTAddLessDiscValue,
          iALBillDiscId: HT.iAddLessBillDiscId,
        })
      );
      // switch the POS screen to return mode only AFTER the data is in the store
      if (props.View_Return) props.View_Return();
    } catch (err) {
      Show_Message(
        dispatch,
        (err && err.message) || "Unexpected error. Please try again.",
        "error"
      );
    } finally {
      await Pre_Loading(dispatch, false);
      openingRef.current = false;
    }
  };

  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>Return</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={props.Close}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body">
          <div className="input-search">
            <input
              type="text"
              value={strSearch}
              onChange={(e) => Search_Change(e.target.value)}
              className="form-control"
              placeholder="Search bill number ...."
              autoFocus
              autoComplete="off"
              onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  e.preventDefault();
                  focusItem(0);
                } else if (e.key === "Enter") {
                  if (searchTimer.current) {
                    // search still pending: run it now instead of opening a stale row
                    clearTimeout(searchTimer.current);
                    searchTimer.current = null;
                    fetchVouchers(strSearch, strFromDate, strToDate);
                  } else if (VouchersList.length > 0) {
                    View_PosReturn(VouchersList[0].vouchId);
                  }
                }
              }}
            />
            <input
              type="date"
              value={strFromDate}
              onChange={(e) => Date_Change(true, e.target.value)}
              className="form-control"
              autoComplete="off"
            />
            <input
              type="date"
              value={strToDate}
              onChange={(e) => Date_Change(false, e.target.value)}
              className="form-control"
              autoComplete="off"
            />
          </div>
          <div className="pos-view">
            {!isLoading && VouchersList.length === 0 && (
              <div
                style={{ textAlign: "center", padding: "24px", color: "#888" }}
              >
                No invoices found
              </div>
            )}
            {VouchersList.map((Vouch, trIndex) => (
              <button
                key={Vouch.vouchId}
                ref={(el) => (itemRefs.current[trIndex] = el)}
                onClick={() => setiVouchId(Vouch.vouchId)}
                onFocus={() => setiVouchId(Vouch.vouchId)}
                onDoubleClick={() => View_PosReturn(Vouch.vouchId)}
                onKeyDown={(e) => {
                  const last = VouchersList.length - 1;
                  if (e.key === "ArrowDown") {
                    e.preventDefault();
                    focusItem(trIndex === last ? 0 : trIndex + 1);
                  } else if (e.key === "ArrowUp") {
                    e.preventDefault();
                    focusItem(trIndex === 0 ? last : trIndex - 1);
                  } else if (e.key === "Enter") {
                    e.preventDefault();
                    View_PosReturn(Vouch.vouchId);
                  }
                  // Escape is handled once by the document listener
                }}
              >
                <div className="bill-content">
                  <h6>{Vouch.partyName}</h6>
                  <div className="trans-cont">
                    <div className="transview1">
                      <label>
                        <span>Inv No : {Vouch.vouchNo}</span>
                        <span>Date : {Vouch.vouchDate}</span>
                        <span>Qty : {Number(Vouch.tQty).toFixed(2)}</span>
                        <span>Tax Amount : {fmtINR(Vouch.tTaxAmt)}</span>
                        <span>Net Amount : {fmtINR(Vouch.netAmt)}</span>
                      </label>
                      <label></label>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
        <div className="pos-btn-group">
          <div className="pos-tooltip" onClick={(e) => Run_SelectedPrint(e, "Print")}>
            <a className="icon-btn" href="##">
              <i className="fa-solid fa-print"></i>
            </a>
            <span className="pos-tooltiptxt">Print</span>
          </div>
          <div
            className="pos-tooltip"
            onClick={(e) => Run_SelectedPrint(e, "PDF")}
          >
            <a className="icon-btn" href="##">
              <i className="fa-solid fa-download"></i>
            </a>
            <span className="pos-tooltiptxt">Download</span>
          </div>
          <div
            className="pos-tooltip"
            onClick={(e) => Run_SelectedShare(e, "WhatsApp")}
          >
            <a className="icon-btn" href="##">
              <i className="fa-brands fa-whatsapp"></i>
            </a>
            <span className="pos-tooltiptxt">whatsapp</span>
          </div>
          <div className="pos-tooltip" onClick={(e) => Run_SelectedShare(e, "Email")}>
            <a className="icon-btn" href="##">
              <i className="fa-regular fa-envelope"></i>
            </a>
            <span className="pos-tooltiptxt">E-mail</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default POSReturn;